import React from 'react';
import { EVENT_TYPE, PERIODS } from '../../../constants/match';

function getFallbackDescription(event) {
  if (
    event.type === EVENT_TYPE.PERIOD_RESULT &&
    event?.period === PERIODS.PERIOD_FIRST_HALF
  ) {
    return 'PAUS';
  }
  if (
    event.type === EVENT_TYPE.START &&
    event?.period === PERIODS.PERIOD_FIRST_HALF
  ) {
    return 'AVSPARK FÖRSTA HALVLEK';
  }
  if (
    event.type === EVENT_TYPE.START &&
    event?.period === PERIODS.PERIOD_SECOND_HALF
  ) {
    return 'AVSPARK ANDRA HALVLEK';
  }

  if (
    event.type === EVENT_TYPE.PERIOD_RESULT &&
    event?.period === PERIODS.PERIOD_SECOND_HALF
  ) {
    return `MATCH SLUTAR ${event?.homeTeamScore}-${event?.visitingTeamScore}`;
  }

  return '';
}

function GameEventStart({ event }) {
  const description = event?.description || getFallbackDescription(event);

  return (
    <div className="match-timeline__row text-small fw-bold gap-2 mb-4">
      <object
        height="12"
        data="/wp-content/themes/sef-leagues/images/event-whistle-logo.svg"
        type="image/svg+xml"
      ></object>
      {description}
    </div>
  );
}

export default GameEventStart;
